export const filterTranslationInput = {
  methods: {
    filterTranslationInput (option, label, search) {
      if (label.length > 2) {
        return true
      } else {
        return (label | '').toLowerCase().indexOf(search.toLowerCase()) > -1
      }
    }
  }
}
